import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {TopeCanal} from '../_models/tope-canal';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopeCanalService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/topesCanales';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado(): Observable<TopeCanal[]> {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TopeCanal[] ) );
  }

  listadoHabilitados(): Observable<TopeCanal[]> {
    return this.httpClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as TopeCanal[] ) );
  }

  obtenerPorId( id: string ): Observable<TopeCanal> {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as TopeCanal ) );
  }

  crear( regCrear: TopeCanal ): Observable<TopeCanal> {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TopeCanal ) );
  }

  actualizar( regActualizar: TopeCanal ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
